import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {DataGridColumnAlignments, DataGridColumnTypes, useDataGridSavedState,} from "../../../../../../../../../packages/data-grid";
import {VendorPurchaseItemsDataGridCellKeys} from "../../../../../../../../../core/constants/table/data-grid-column-keys";
import PartnerDataGrid from "../../../../../../../../containers/data-grid";
import {formatMoney} from "../../../../../../../../../core/services/utils/utils";

/**
 * Purchase order items tab PartnerDataGrid section.
 */
const PurchaseOrdersListItemsSection = ({
                                            data,
                                            searchData,
                                            dataGridSaveConfig,
                                            getExportInfo,
                                        }) => {
    const {t} = useTranslation('views', {keyPrefix: 'app-specific.purchases.ordersList'});

    const columns = useMemo(() => /** @type {DataGridColumn[]} */ ([
        {
            title: t('columns.vendorPartNo'),
            name: VendorPurchaseItemsDataGridCellKeys.vendorPartNo,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.left,
        },
        {
            title: t('columns.partNo'),
            name: VendorPurchaseItemsDataGridCellKeys.partNo,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.left,
        },
        {
            title: t('columns.description'),
            name: VendorPurchaseItemsDataGridCellKeys.description,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.left,
        },
        {
            title: t('columns.qty'),
            name: VendorPurchaseItemsDataGridCellKeys.qty,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.right,
        },
        {
            title: t('columns.unitPrice'),
            name: VendorPurchaseItemsDataGridCellKeys.unitPrice,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.right,
        },
        {
            title: t('columns.total'),
            name: VendorPurchaseItemsDataGridCellKeys.total,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.right,
        },
        {
            title: t('columns.serials'),
            name: VendorPurchaseItemsDataGridCellKeys.serials,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.left,
        },
    ]), [t]);

    const [dataGridColumns, , , density] = useDataGridSavedState({
        columns,
        name: dataGridSaveConfig.name,
        version: dataGridSaveConfig.version,
    });

    const rows = useMemo(() => data.map((row) => ({
        key: row.id,
        data: row,
        cells: {
            [VendorPurchaseItemsDataGridCellKeys.vendorPartNo]: row.vendorPartNo,
            [VendorPurchaseItemsDataGridCellKeys.partNo]: row.partNo,
            [VendorPurchaseItemsDataGridCellKeys.description]: row.description,
            [VendorPurchaseItemsDataGridCellKeys.qty]: row.qty,
            [VendorPurchaseItemsDataGridCellKeys.unitPrice]: formatMoney(row.unitPrice),
            [VendorPurchaseItemsDataGridCellKeys.total]: formatMoney(row.total),
            [VendorPurchaseItemsDataGridCellKeys.serials]: row.serials,
        },
    })), [data]);

    return (
        <PartnerDataGrid
            {...dataGridSaveConfig}
            initialLayoutState={{columns}}
            columns={dataGridColumns}
            rows={rows}
            hideFooterActions
            getExportInfo={getExportInfo}
            state={{
                pagination: searchData.paginationInfo,
                sortBy: searchData.orderBy,
                loading: {state: searchData.loading},
                density,
            }}
            onSortByChanged={(_, current) => searchData.setOrderBy(current)}
            onCurrentPageChanged={(_, current) => searchData.setPaginationInfo((prev) => ({...prev, ...current}))}
            onPageSizeChanged={(_, current) => searchData.setPaginationInfo((prev) => ({...prev, ...current}))}
        />
    );
};

export default PurchaseOrdersListItemsSection;
